import { useState, useEffect } from "react";
import { useModalStore } from "../../../stores/modalStore.js";
import { useFriendStore } from "../../../stores/friendStore.js";

export function GroupDMModal() {
  const { isOpen, type, onClose } = useModalStore();
  const friends = useFriendStore(s => s.friends);

  const [name,     setName]     = useState('');
  const [selected, setSelected] = useState([]);
  const [search,   setSearch]   = useState('');
  const [creating, setCreating] = useState(false);
  const [done,     setDone]     = useState(null);

  useEffect(() => { if (isOpen && type === 'groupDM') { setName(''); setSelected([]); setSearch(''); setDone(null); } }, [isOpen, type]);

  if (!isOpen || type !== 'groupDM') return null;

  const filtered = friends.filter(f =>
    (f.name || f.username || '').toLowerCase().includes(search.toLowerCase())
  );

  const toggle = (id) => setSelected(s => s.includes(id) ? s.filter(x => x !== id) : s.length < 9 ? [...s, id] : s);

  const handleCreate = async () => {
    if (selected.length === 0) return;
    setCreating(true);
    try {
      const res = await fetch('/api/gdm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('auth_token')}` },
        body: JSON.stringify({ participantIds: selected, name: name.trim() || undefined }),
      });
      const d = await res.json();
      if (d.success) setDone(d.gdm);
    } catch (_) {}
    setCreating(false);
  };

  if (done) {
    return (
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
        <div style={{ width: 380, background: 'var(--bg-primary,#13141f)', borderRadius: 16, boxShadow: '0 24px 64px rgba(0,0,0,0.6)', padding: '40px 32px', textAlign: 'center' }}
          onClick={e => e.stopPropagation()}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>💬</div>
          <div style={{ fontSize: 17, fontWeight: 700, color: '#fff', marginBottom: 8 }}>Group DM Created!</div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', marginBottom: 24 }}>
            {done.name || `Group with ${done.participants.length} members`}
          </div>
          <button onClick={onClose}
            style={{ padding: '10px 28px', borderRadius: 10, background: 'var(--color-primary,#6366f1)', border: 'none', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
            Done
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onClose}>
      <div style={{ width: '100%', maxWidth: 480, maxHeight: '85vh', display: 'flex', flexDirection: 'column', background: 'var(--bg-primary,#13141f)', borderRadius: 16, boxShadow: '0 24px 64px rgba(0,0,0,0.6)', overflow: 'hidden' }}
        onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid rgba(255,255,255,0.07)', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
            <div style={{ fontSize: 17, fontWeight: 700, color: '#fff' }}>💬 New Group DM</div>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', fontSize: 18, cursor: 'pointer' }}>✕</button>
          </div>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="Group name (optional)"
            style={{ width: '100%', padding: '8px 12px', borderRadius: 8, background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', fontSize: 13, outline: 'none', boxSizing: 'border-box', marginBottom: 8 }} />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search friends…"
            style={{ width: '100%', padding: '8px 12px', borderRadius: 8, background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
        </div>

        {/* Selected chips */}
        {selected.length > 0 && (
          <div style={{ padding: '8px 24px', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', gap: 6, flexWrap: 'wrap', flexShrink: 0 }}>
            {selected.map(id => {
              const f = friends.find(x => x.id === id);
              return (
                <span key={id} style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '3px 10px', borderRadius: 20, background: 'rgba(99,102,241,0.2)', border: '1px solid rgba(99,102,241,0.35)', fontSize: 12, color: '#a5b4fc' }}>
                  {f?.name || f?.username || id}
                  <button onClick={() => toggle(id)} style={{ background: 'none', border: 'none', color: 'rgba(165,180,252,0.6)', cursor: 'pointer', padding: 0, fontSize: 12, lineHeight: 1 }}>✕</button>
                </span>
              );
            })}
          </div>
        )}

        {/* Friend list */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '8px 16px' }}>
          {filtered.length === 0 ? (
            <div style={{ padding: '24px 0', textAlign: 'center', color: 'rgba(255,255,255,0.3)', fontSize: 13 }}>
              {friends.length === 0 ? 'Add some friends first' : 'No friends match'}
            </div>
          ) : (
            filtered.map(f => {
              const sel = selected.includes(f.id);
              return (
                <div key={f.id} onClick={() => toggle(f.id)}
                  style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 8px', borderRadius: 8, cursor: 'pointer', transition: 'background 0.1s', background: sel ? 'rgba(99,102,241,0.12)' : 'transparent' }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = 'transparent'; }}>
                  <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#6366f1,#06b6d4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
                    {(f.name || f.username || '?')[0].toUpperCase()}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, color: '#fff', fontWeight: 500 }}>{f.name || f.username}</div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>Friend</div>
                  </div>
                  <div style={{ width: 20, height: 20, borderRadius: 6, border: `2px solid ${sel ? 'var(--color-primary,#6366f1)' : 'rgba(255,255,255,0.2)'}`, background: sel ? 'var(--color-primary,#6366f1)' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: '#fff', transition: 'all 0.15s' }}>
                    {sel && '✓'}
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '14px 24px', borderTop: '1px solid rgba(255,255,255,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)' }}>{selected.length}/9 selected</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={onClose} style={{ padding: '8px 18px', borderRadius: 8, background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.7)', fontSize: 13, cursor: 'pointer' }}>Cancel</button>
            <button onClick={handleCreate} disabled={selected.length === 0 || creating}
              style={{ padding: '8px 20px', borderRadius: 8, background: 'var(--color-primary,#6366f1)', border: 'none', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: selected.length === 0 ? 0.5 : 1 }}>
              {creating ? 'Creating…' : 'Create Group'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
